import React, { useEffect, useState } from "react";
import FormField from "./FormField";
import CheckColor from "./CheckColor";
import PhotoHolder from "./PhotoHolder";
import EventHeader from "./EventHeader";
import YesNoOrField from "./YesNoOrField";
import Dropdown from "./Dropdown";

const Events = ({ index }) => {
  const [risk_categories] = useState(
    () => JSON.parse(localStorage.getItem("risk_categories")) || []
  );
  const [risk_sub_categories] = useState(
    () => JSON.parse(localStorage.getItem("risk_sub_categories")) || []
  );
  const [risk_sub_categories_type] = useState(
    () => JSON.parse(localStorage.getItem("risk_sub_categories_type")) || []
  );
  const [risk_solutions] = useState(
    () => JSON.parse(localStorage.getItem("risk_solutions")) || []
  );
  const [company_type] = useState(
    () => JSON.parse(localStorage.getItem("company_type")) || []
  );

  const [riskChange, setRiskChange] = useState(false);
  const [riskTypeChange, setRiskTypeChange] = useState(false);
  const [riskTypeExampleChange, setRiskTypeExampleChange] = useState(false);
  const [risks, setRisks] = useState([]);
  const [risksSubHeading, setRisksSubHeading] = useState([]);
  const [risksTypeheading, setRiskTypeheading] = useState([]);
  const [risksTypeExample, setRisksTypeExample] = useState([]);
  const [showExample, setShowExample] = useState(false);
  const [exampleOptions, setExampleOptions] = useState([]);
  const [selectedExample, setSelectedExample] = useState(null);
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [isSelectedSolutionDisabled, setIsSelectedSolutionDisabled] =
    useState(false);
  const [riskSolutions, setRiskSolutions] = useState([]);
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    const loggedInCompanyId = JSON.parse(localStorage.getItem("company_id"));
    const displayOnlyPrivateData = localStorage.getItem(
      "display_only_private_data"
    );

    let filteredCompanyTypes = [];
    let filteredCompanies = [];

    if (displayOnlyPrivateData === "yes") {
      filteredCompanyTypes = company_type.filter(
        (comp) => comp.company_id === loggedInCompanyId
      );
    } else if (displayOnlyPrivateData === "no" && loggedInCompanyId !== null) {
      const groupedByTypeName = company_type.reduce((acc, comp) => {
        if (!acc[comp.name]) {
          acc[comp.name] = [];
        }
        acc[comp.name].push(comp);
        return acc;
      }, {});

      filteredCompanies = Object.values(groupedByTypeName).map((group) => {
        return (
          group.find((comp) => comp.company_id === loggedInCompanyId) ||
          group[0]
        );
      });

      console.log(filteredCompanies);

      filteredCompanyTypes = filteredCompanies.filter(
        (comp) =>
          comp.company_id === loggedInCompanyId || comp.company_id === null
      );

      console.log(filteredCompanyTypes);
    } else {
      filteredCompanyTypes = company_type.filter(
        (comp) => comp.company_id === null
      );
    }

    const formattedCompanies = filteredCompanyTypes.map((comp) => ({
      title: comp.name,
      value: comp.id,
    }));
    setCompany(formattedCompanies);
  }, [index, risk_categories, company_type, risk_sub_categories]);

  const handleCompanySelection = (selectedCompanyId) => {
    setSelectedCompany(selectedCompanyId);
    setSelectedExample(null);
    setRisksSubHeading([]);
    setRiskTypeheading([]);
    setRisksTypeExample([]);
    setRiskSolutions([]);

    const filteredRisks = risk_categories.filter(
      (risk) => risk.company_type_id === selectedCompanyId
    );
    setRisks(
      filteredRisks.map((risk) => ({ title: risk.name, value: risk.id }))
    );
  };

  useEffect(() => {
    setShowExample(false);
    setRiskTypeheading([]);
    setRisksTypeExample([]);
    setExampleOptions([]);
    setSelectedExample(null);

    let gefahrdung = JSON.parse(localStorage.getItem("gefahrdung" + index));
    if (gefahrdung) {
      let _risksSubheading = risk_sub_categories
        .filter((sub) => sub.risk_category_id === gefahrdung)
        .map((sub) => ({ title: sub.name, value: sub.id }));
      setRisksSubHeading(_risksSubheading);
      setShowExample(true);
    } else {
      setShowExample(false);
    }
  }, [selectedCompany, riskChange, index, risk_sub_categories]);

  useEffect(() => {
    setShowExample(false);
    setRiskTypeheading([]);
    setRisksTypeExample([]);
    let gefahrdung_unterkategorie = JSON.parse(
      localStorage.getItem("gefahrdung_unterkategorie" + index)
    );
    if (gefahrdung_unterkategorie) {
      let _risksTypeheading = risk_sub_categories_type
        .filter(
          (type) => type.risk_sub_categories_id === gefahrdung_unterkategorie
        )
        .map((type) => ({ title: type.name, value: type.id }));
      setRiskTypeheading(_risksTypeheading);
      setSelectedExample(null);
      setRiskSolutions([]);
    }
  }, [riskTypeChange, index, risk_sub_categories_type]);

  useEffect(() => {
    const gefahrdung_unterkategorie_type = JSON.parse(
      localStorage.getItem("gefahrdung_unterkategorie_type" + index)
    );

    if (gefahrdung_unterkategorie_type) {
      const newRisksTypeExample = risk_sub_categories_type
        .filter(
          (exp) =>
            exp.id === gefahrdung_unterkategorie_type &&
            exp.example &&
            exp.example.trim()
        )
        .map((exp) => ({ title: exp.example }));

      setRisksTypeExample(newRisksTypeExample);
      const exampleData = newRisksTypeExample.map((exp) => ({
        title: exp.title,
        value: exp.title,
      }));
      setExampleOptions(exampleData);
      setSelectedExample(gefahrdung_unterkategorie_type);

      const solutions = risk_solutions.filter(
        (solution) =>
          solution.risk_sub_category_type_id === gefahrdung_unterkategorie_type
      );
      const mappedSolutions = solutions.map((solution) => ({
        title: solution.name,
        value: solution.id,
      }));
      setRiskSolutions([...mappedSolutions]);
    } else {
      setRisksTypeExample([]);
      setExampleOptions([]);
      setSelectedExample(null);
      setRiskSolutions([]);
    }
  }, [index, riskTypeExampleChange, risk_sub_categories_type, risk_solutions]);

  const handleProtectiveMeasureChange = (e) => {
    const protectiveMesaure = e.target.value;
    if (protectiveMesaure != null && protectiveMesaure.length > 0) {
      setIsSelectedSolutionDisabled(true);
    } else {
      setIsSelectedSolutionDisabled(false);
    }
  };

  return (
    <div
      id={"event" + index}
      className="shadow"
      style={{
        marginTop: 10,
        marginBottom: 40,
        borderRadius: 10,
        padding: 10,
        overflow: "hidden",
      }}
    >
      <div
        className="card"
        style={{
          marginTop: 10,
          padding: 10,
        }}
      >
        <EventHeader index={index} />
        <div id={"eventholder" + index}>
          <Dropdown
            id={"company" + index}
            title={<span>Unternehmenstyp*</span>}
            options={company}
            valueChange={selectedCompany}
            setValueChange={handleCompanySelection}
          />
          {selectedCompany && (
            <Dropdown
              id={"gefahrdung" + index}
              title={<span>Gefahrdung*</span>}
              options={risks}
              valueChange={riskChange}
              setValueChange={() => setRiskChange(!riskChange)}
            />
          )}
          {risksSubHeading.length > 0 && (
            <Dropdown
              id={"gefahrdung_unterkategorie" + index}
              title={<span>Gefährdung Unterkategorie*</span>}
              options={risksSubHeading}
              valueChange={riskTypeChange}
              setValueChange={setRiskTypeChange}
            />
          )}
          {risksTypeheading.length > 0 && (
            <Dropdown
              id={"gefahrdung_unterkategorie_type" + index}
              title={<span>Gefährdung Unterkategorie Type*</span>}
              options={risksTypeheading}
              valueChange={riskTypeExampleChange}
              setValueChange={setRiskTypeExampleChange}
            />
          )}
          {risksTypeExample.length > 0 && (
            <div
              style={{
                fontSize: "16px",
                display: "flex",
                alignItems: "center",
                padding: "10px 15px",
                borderRadius: "0.5rem",
                background: "#ececec",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <span>z.B:</span>
              {risksTypeExample.map((exp, idx) => (
                <div key={idx} style={{ marginLeft: "8px" }}>
                  {exp.title}
                </div>
              ))}
            </div>
          )}

          {selectedExample && (
            <>
              <Dropdown
                id={"exampleDropdown" + index}
                title={<span>Lösung*</span>}
                options={riskSolutions}
                valueChange={selectedSolution}
                displayClearButton={true}
                setValueChange={setSelectedSolution}
                disabled={isSelectedSolutionDisabled}
              />
              <span>-------------bzw.-------------</span>
            </>
          )}
          {selectedExample && (
            <FormField
              label={<span>Vorgeschlagene Schutzmaßnahme*</span>}
              id={"vorgeschlageneschutzmassnahme" + index}
              type={"text"}
              disabled={selectedSolution === null ? false : true}
              handleChange={handleProtectiveMeasureChange}
            />
          )}
          <FormField
            label={<span>Festgestellter Mangel*</span>}
            id={"festgestellter_mangel" + index}
            type={"text"}
          />
          <YesNoOrField index={index} />
          <FormField
            label={<span>Ort*</span>}
            id={"ort" + index}
            type={"text"}
          />
          <FormField
            label={
              <span>
                Verursacht durch (wenn bekannt){" "}
                <i style={{ fontSize: "12px" }}>(optional)</i>
              </span>
            }
            id={"verursachtdurch" + index}
            type={"text"}
          />
          <FormField
            label={
              <span>
                Gewerk <i style={{ fontSize: "12px" }}>(optional)</i>
              </span>
            }
            id={"gewerk" + index}
            type={"text"}
          />
          <CheckColor index={index} />

          <PhotoHolder index={index} />
        </div>
      </div>
    </div>
  );
};

export default Events;
